module.exports = __webpack_public_path__ + "c_static/img/tip.4910ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/tip.png
// module id = C2V4
// module chunks = 33